import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  shadow?: 'none' | 'sm' | 'md' | 'lg';
  onClick?: () => void;
  bordered?: boolean;
}

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  hover = false,
  padding = 'md',
  shadow = 'sm',
  onClick,
  bordered = true,
}) => {
  const paddingClasses = {
    none: '',
    sm: 'p-3',
    md: 'p-5',
    lg: 'p-6',
  };

  const shadowClasses = {
    none: '',
    sm: 'shadow-soft',
    md: 'shadow-soft-md',
    lg: 'shadow-soft-lg',
  };

  const baseClasses = 'bg-white rounded-xl transition-all duration-200';
  const borderClasses = bordered ? 'border border-neutral-200/80' : '';
  const hoverClasses = hover
    ? 'hover:shadow-soft-md hover:border-neutral-300 hover:-translate-y-0.5'
    : '';
  const clickableClasses = onClick ? 'cursor-pointer active:scale-[0.99]' : '';

  const classes = [
    baseClasses,
    borderClasses,
    paddingClasses[padding],
    shadowClasses[shadow],
    hoverClasses,
    clickableClasses,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} onClick={onClick}>
      {children}
    </div>
  );
};

export default Card;
